import { render } from "./ExampleQueries.vue?vue&type=template&id=0c89a1d2&scoped=true&ts=true"
import script from "./ExampleQueries.vue?vue&type=script&lang=ts"
export * from "./ExampleQueries.vue?vue&type=script&lang=ts"

import "./ExampleQueries.vue?vue&type=style&index=0&id=0c89a1d2&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src866133389/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c89a1d2"]])

export default __exports__